import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'
import { rememberPaymentFlow } from 'utilities/analytics/paymentFlow'
import { setSubscriptionPayment } from 'services/plan'

export default function useSetPayment() {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISetSubscriptionPaymentPayload) => {
            return setSubscriptionPayment(payload)
        },
        onSuccess: (result, variables) => {
            localStorage.setItem(
                'toBePaidTransactions',
                JSON.stringify({ type: 'subscription', data: [] })
            )
            posthog.capture('payment_gateway_redirect', {
                flow_type: 'subscription',
                amount: variables?.amount,
                month_count: variables?.monthCount,
                gateway: variables?.gatewayCode,
                has_discount: !!variables?.discountCode,
            })
            rememberPaymentFlow({
                flow_type: 'subscription',
                amount: variables?.amount ?? null,
                gateway: variables?.gatewayCode ?? null,
                box_id: variables?.ctxId ?? null,
                box_type: 'mnp',
                month_count: variables?.monthCount ?? null,
            })
            // `payment_link` is null when the backend settled the purchase
            // outright (a basket the wallet covered). This screen never asks
            // for that, so an absent link here is a failure — and
            // `replace(null)` navigates to the literal string "null", which is
            // how a payment turns into a blank page.
            if (!result?.payment_link) {
                posthog.capture('subscription_purchase_failed', {
                    reason: 'no_payment_link',
                })
                toast.error('مشکلی پیش آمده!')
                return
            }
            window.location.replace(result.payment_link)
        },
        onError: (error: any) => {
            posthog.capture('subscription_purchase_failed', {
                status: error?.response?.status,
            })
            // The backend sends actionable Persian text here (e.g. the gateway
            // allowlist rejection); show it instead of a generic failure.
            const detail = error?.response?.data?.error
            toast.error(
                typeof detail === 'string' && detail ? detail : 'مشکلی پیش آمده!'
            )
        },
    })
    return { mutate, isLoading }
}
